import { render, staticRenderFns } from "./BillOfMaterials.vue?vue&type=template&id=3d97fa34&scoped=true"
import script from "./BillOfMaterials.vue?vue&type=script&lang=js"
export * from "./BillOfMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97fa34",
  null
  
)

export default component.exports